// extracted by mini-css-extract-plugin
export default {"a0":"SimplePaperPodcast-cls1__Sz","cls1":"SimplePaperPodcast-cls1_h8h","cls2":"SimplePaperPodcast-cls2_oJc SimplePaperPodcast-cls1_h8h"};